import React from 'react';
import PropTypes from 'prop-types';
import pageWrapper from '../../hoc/pageWrapper';
import withNewestApartments from '../../hoc/withNewestApartments';
import withNewestArticles from '../../hoc/withNewestArticles';
import * as StyledFrontpage from './frontpage.styles';
import Hero from '../../components/hero';
import ApartmentShowcase from '../../components/apartmentShowcase';
import ArticleShowcase from '../../components/articleShowcase';
import NavigationalCards from '../../components/navigationalCards';

const NewestApartments = withNewestApartments(ApartmentShowcase);
const NewestArticles = withNewestArticles(ArticleShowcase);

const Frontpage = ({ page }) => {
	const url = page.Values.ApartmentListNode ? page.Values.ApartmentListNode.Url : '';
	const {
		HeroTitle,
		HeroText,
		ImageUrl,
		ImageRightSideOnly
	} = page.Values;
	return (
		<StyledFrontpage.Wrapper>
			<Hero title={HeroTitle} text={HeroText} imageUrl={ImageUrl.Src} imageRightSideOnly={ImageRightSideOnly} url={url} />
			<NewestApartments />
			<NavigationalCards cards={page.Values.UrlBoxes} />
			<NewestArticles />
		</StyledFrontpage.Wrapper>
	);
};

Frontpage.propTypes = {
	page: PropTypes.object
};

Frontpage.defaultProps = {
	page: null
};

export default pageWrapper(Frontpage);
